import { render, staticRenderFns } from "./AddBotsModal.vue?vue&type=template&id=47d6f810&"
import script from "./AddBotsModal.vue?vue&type=script&lang=ts&"
export * from "./AddBotsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports